// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"8ee9e011","223":"9bfc6365","226":"0e41ee08","525":"1cc76a27","671":"244f8e96","784":"29c5d408","787":"59fd8b51","967":"cc74a385"}[chunkId] + ".chunk.js";
};